export default __webpack_public_path__ + "static/media/HYD-3.290de254.webp";